import { getYoutubeId } from '@/utils/getYoutubeId';
import React, { useEffect, useState } from 'react';

function YouTubeViewer(props) {
  const { linkUrl } = props;
  const [youtubeUrl, setYoutubeUrl] = useState();

  useEffect(() => {
    const youtubeVideoId = getYoutubeId(linkUrl);
    const youtubeLink = `https://www.youtube.com/embed/${youtubeVideoId}`;
    setYoutubeUrl(youtubeLink);
  }, [linkUrl]);

  return (
    <iframe
      width="100%"
      height="100%"
      style={{ objectFit: 'contain' }}
      src={youtubeUrl}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  );
}

export default YouTubeViewer;
